<template>
  <v-layout row wrap justify="start">
    <v-flex xs12>
      <label>Date Range</label>
      <v-select
        v-model="input.range"
        :items="fixedRanges"
        item-value="value"
        item-text="label"
        placeholder="Select Timerange"
        size="large"
        style="width: 100%; padding: 0"
        hide-details
        @change="handleRangeChange"
      />
    </v-flex>
    <v-flex xs12 class="mt-3">
      <label>Start/End Date</label>
      <date-range-picker
        opens="right" :max-date="new Date()"
        v-model="input.date"
        :placeholder="['Start Date', 'End Date']"
        :disabled="input.range !== 'custom'"
        control-container-class="bt-date-range"
        size="large"
        style="width: 100%"
        @update="updateModel('submit')" />
    </v-flex>
    <v-layout row wrap class="mt-3">
      <v-spacer />
      <v-flex>
        <v-btn
          style="float: right"
          size="large"
          color="primary"
          class="mr-0"
          @click="updateModel('submit')"
          >Apply</v-btn>
          <v-btn
          style="float: right"
          size="large"
          color="error"
          outline
          @click="$emit('close')"
          >Cancel</v-btn>
    </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import fixedRanges from './fixedRanges'
import DateRangePicker from 'vue2-daterange-picker'
export default {
  name: 'DateRange',
  components: {
    DateRangePicker
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      fixedRanges,
      input: {
        range: 'thisWeek',
        date: {
          startDate: this.$moment(this.$moment().add(-1, 'week')).format('YYYY/MM/DD'),
          endDate: this.$moment().format('YYYY/MM/DD')
        },
      }
    }
  },
  computed: {
    thisWeek() {
      return {
        startDate: this.$moment(this.$moment().add(-1, 'week')).format('YYYY/MM/DD'),
        endDate: this.$moment().format('YYYY/MM/DD')
      }
    },
    lastWeek() {
      return {
        startDate: this.$moment(this.$moment().add(-2, 'week')).format('YYYY/MM/DD'),
        endDate: this.$moment(this.$moment().add(-1, 'week')).format('YYYY/MM/DD')
      }
    },
    thisMonth() {
      return {
        startDate: this.$moment(this.$moment().add(-1, 'M')).format('YYYY/MM/DD'),
        endDate: this.$moment().format('YYYY/MM/DD')
      }
    },
    lastMonth() {
      return {
        startDate: this.$moment(this.$moment().add(-2, 'M')).format('YYYY/MM/DD'),
        endDate: this.$moment(this.$moment().add(-1, 'M')).format('YYYY/MM/DD')
      }
    },
    thisQuarter() {
      return {
        startDate: this.$moment(this.$moment().add(-3, 'M')).format('YYYY/MM/DD'),
        endDate: this.$moment().format('YYYY/MM/DD')
      }
    },
    lastQuarter() {
      return {
        startDate: this.$moment(this.$moment().add(-6, 'M')).format('YYYY/MM/DD'),
        endDate: this.$moment(this.$moment().add(-3, 'M')).format('YYYY/MM/DD')
      }
    },
    thisYear() {
      return {
        startDate: this.$moment(this.$moment().add(-1, 'y')).format('YYYY/MM/DD'),
        endDate: this.$moment().format('YYYY/MM/DD')
      }
    },
    lastYear() {
      return {
        startDate: this.$moment(this.$moment().add(-2, 'y')).format('YYYY/MM/DD'),
        endDate: this.$moment(this.$moment().add(-1, 'y')).format('YYYY/MM/DD')
      }
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val, before) {
        if (val && val.date) {
          // console.log('change', val, before)
          this.input = val
          this.handleRangeChange()
        } else {
          // console.log('nochange', val, before)
        }
      }
    },
  },
  mounted() {
    this.handleRangeChange()
    this.updateModel()
  },
  methods: {
    handleRangeChange() {
      if (this.input.range !== 'custom') {
        this.input.date = this[this.input.range]
      }
    },
    updateModel(event) {
      this.$emit('input', this.input)
      if (event === 'submit') this.$emit('submit', this.input)
    }
  }
}
</script>
<style lang="css">
.bt-date-range {
  border: solid 1px rgba(13, 108, 176, 0.09) !important;
    -webkit-appearance: none !important;
    border-radius: 8px !important;
    padding: 8px !important;
    padding-top: 10px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
</style>